<template>
  <div :class="['address-card', {primary: isPrimary}]">
    <template v-if="!button">
      <div class="address-card-wrapper" @click="$emit('on-edit')">
        <div class="title">
          {{ address.name }}
        </div>
        <div class="description">
          {{ details }}
        </div>
        <span
          v-if="isPrimary"
          class="label"
        >
          Основной
        </span>
      </div>

      <div
        :class="['dots-button', { active: showActions }]"
        @click="showActions = !showActions"
      >
        <f-sprite-icon :icon-link="$options.icons.IconDots.id" />

        <ui-dropdown
          right
          @on-close="showActions = false"
          :visible="showActions"
        >
          <div class="actions">
            <span
              v-if="!isPrimary"
              @click="$emit('on-primary')"
            >
              Сделать основным
            </span>
            <span @click="$emit('on-edit')">
              Редактировать
            </span>
            <span @click="remove">
              Удалить
            </span>
          </div>
        </ui-dropdown>
      </div>
    </template>

    <template v-else>
      <div
        :class="['button', {disabled: disabled}]"
        @click="$emit('open')"
      >
        <div>
          <f-sprite-icon :icon-link="$options.icons.IconPlus.id" />
        </div>
        <span>{{ button }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import IconPlus from '@icons/plus.svg';
import IconDots from '@icons/dots.svg';
import addressToString from '@/utils/addressToString';

export default {
  name: 'address-card',

  icons: {
    IconPlus,
    IconDots,
  },

  props: {
    address: {
      type: Object,
      default: () => {}
    },

    button: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    showActions: false,
  }),

  computed: {
    details() {
      if (!this.address) return '';
      return addressToString(this.address);
    },

    isPrimary() {
      return this.address?.primary;
    }
  },
  methods: {
    remove() {
      this.$store.$api.removeAddress({addressId: this.address.id}).then(() => {
        this.$emit('on-removed');
      });
    },
  },
};
</script>

<style lang="scss">
.address-card {
  position: relative;
  min-height: 120px;
  border: 1px solid $gray_lu;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .04), 0 8px 24px rgba(0, 0, 0, .03), 0 16px 32px rgba(0, 0, 0, .02);

  &.primary {
    .description {
      -webkit-line-clamp: 1;
    }
  }

  &-wrapper {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 12px 36px 12px 12px;
  }

  .title {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
  }

  .title,
  .description {
    /* stylelint-disable-next-line */
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .dots-button {
    position: absolute;
    top: 12px;
    right: 12px;
    svg {
      width: 20px;
      height: 20px;
      color: $gray_l;
    }
    &.active {
      svg {
        color: $blue;
      }
    }
  }

  .description {
    width: 100%;
    margin-top: 4px;
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 16px;
    color: $gray;
  }

  .ui-dropdown {
    top: 20px;
    right: -4px;
  }

  .label {
    display: inline-block;
    align-self: flex-start;
    margin-top: auto;
    padding: 2px 4px;
    font-size: 10px;
    line-height: 16px;
    font-weight: 600;
    border-radius: 4px;
    background-color: $blue;
    color: #fff;
  }

  .button {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 11px 0;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      padding: 14px;
      border-radius: 50%;
      background-color: rgba($blue_hover, .08);

      svg {
        width: 20px;
        height: 20px;
        color: $blue;
      }
    }

    & > span {
      display: block;
      margin-top: 4px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      color: $blue;
    }

    &.disabled {
      pointer-events: none;
      background-color: $gray_bgr;

      & > div {
        background-color: $gray_lu2;
        svg {
          color: $gray_l;
        }
      }

      & > span {
        color: $gray_l;
      }
    }
  }
}

@include breakpoint("tablet") {
  .address-card {
    min-width: 344px;

    .description {
      /* stylelint-disable-next-line */
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-bottom: 0;
    }

    .ui-dropdown {
      right: 0;
    }
  }
}

@include breakpoint("desktop") {
  .address-card {
    height: 136px;
    cursor: pointer;
    &-wrapper {
      padding: 16px;
    }

    .title {
      font-size: 16px;
      line-height: 24px;
    }

    .description {
      font-size: 14px;
      line-height: 20px;
      -webkit-line-clamp: 2;
    }

    .label {
      padding: 4px 8px;
      font-size: 12px;
      line-height: 16px;
    }

    .dots-button {
      top: 16px;
      right: 16px;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    .ui-dropdown {
      top: 28px;
    }

    .button {
      padding: 8px;
      font-size: 16px;
      line-height: 24px;

      & > div {
        width: 56px;
        height: 56px;

        svg {
          width: 24px;
          height: 24px;
        }
      }

      & > span {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
</style>